import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const postCSVURLBulkUpload = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_CSV_URL_WITH_QUEUE,
    data
  );
};

export default postCSVURLBulkUpload;
